// @flow

import type {OrderPurchaseItem} from './order-purchase-item'
import type {Order} from './order'
import {buildOrderPurchaseItem} from './order-purchase-item'

export type OrderPurchase = {
  id: ?string,
  token: ?string,
  paymentMethodName: ?string,
  paymentIssuerName: ?string,
  discountCode: ?string,
  approvePaymentInTerms: boolean,
  items: { [string]: OrderPurchaseItem }
}

const buildOrderPurchase = function (order: Order): OrderPurchase {
  const orderPurchase = {
    id: order.id,
    token: order.token,
    paymentMethodName: order.paymentMethodName,
    paymentIssuerName: order.paymentIssuerName,
    discountCode: order.discountCode,
    approvePaymentInTerms: order.approvePaymentInTerms,
    items: {}
  }
  Object.keys(order.items).forEach(key => {
    orderPurchase.items[key] = buildOrderPurchaseItem(order.items[key])
  })

  return orderPurchase
}

export {
  buildOrderPurchase
}



// WEBPACK FOOTER //
// ./src/types/order-purchase.js